import { cy } from "../../../../date-fns/locale/cy.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    cy
  }
};